import { render, staticRenderFns } from "./checkbox-wrapper.props.md?vue&type=template&id=08dbcc6e&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../storefront/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports